export default __webpack_public_path__ + "static/media/CharitableGiftAnnuities.60448766.png";